import React from 'react';
import CareConciergeLogo from '../../../../assets/Care_Concierge_Logo.png';

const Header: React.FC = () => {
  return (
    <header className="bg-white border-bottom">
      <div className="container my-0">
        <nav className="navbar navbar-expand-lg bg-white">
          <div className="container-fluid px-0">
            <a className="navbar-brand d-flex align-items-center" href="#" style={{ color: "var(--primary-color)" }}>
              <img 
                src={CareConciergeLogo}
                alt="Care Concierge Logo" 
                width="120" 
                height="50" 
                className="me-3" 
              />
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
